"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dm.communicationType.wa': 'WA',
    'whatsapp.dm.communicationType.tele': 'TELE',
    'whatsapp.dm.loading': 'Loading...',
    'whatsapp.dm.back': 'Back',
    'whatsapp.dm.contactInfo': 'Contact Info',
    'whatsapp.dm.contactName': 'Name',
    'whatsapp.dm.contactId': 'Contact ID',
    'whatsapp.dm.messages': 'Messages',
    'whatsapp.dm.noMessages': 'No messages found for this date range.',
    'whatsapp.dm.dateFrom': 'From',
    'whatsapp.dm.dateTo': 'To',
    'whatsapp.dm.summarize': 'Summarize',
    'whatsapp.dm.summarizeDone': 'DM summary generated successfully.',
    'whatsapp.dm.summarizeFailed': 'Failed to generate DM summary.',
    'whatsapp.dm.botSender': 'Bot',
    'whatsapp.dm.media.attachment': 'Attachment',
    'whatsapp.dm.summaries.title': 'Summaries',
    'whatsapp.dm.summaries.empty': 'No summaries yet.',
    'whatsapp.dm.summaries.date': 'Date',
    'whatsapp.dm.summaries.excerpt': 'Excerpt',
    'whatsapp.dm.summaries.modalTitle': 'DM Summary',
    'whatsapp.dm.stats.contacts': 'Contacts',
    'whatsapp.dm.stats.total': 'Total',
    'whatsapp.dm.syncMessages.button': 'Sync Messages',
    'whatsapp.dm.syncMessages.failed': 'Failed to sync messages.',
};
